import styled from "styled-components";
import { Container } from "react-grid-system";
// import { theme } from "../theme";

export const StyledAddUpperDecisionIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	height: auto;
`;

export const StyledAddUpperDecisionOptions = styled(Container)`
	& > div {
		margin-bottom: 1rem;

		&:last-child {
			margin: 0;
		}
	}
`;

export const StyledModalFooterActions = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	column-gap: 4.5rem;
`;
